import { render, staticRenderFns } from "./WalletListNew.vue?vue&type=template&id=61ebc977&scoped=true&"
import script from "./WalletListNew.vue?vue&type=script&lang=ts&"
export * from "./WalletListNew.vue?vue&type=script&lang=ts&"
import style0 from "./WalletListNew.vue?vue&type=style&index=0&id=61ebc977&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ebc977",
  null
  
)

export default component.exports